import { atom } from "jotai";

import { selectedRoundAtom } from "../../stores";

export const getCourseLayoutHoleCountOnRoundAtom = atom((get) => {
  const selectedRound = get(selectedRoundAtom);
  return selectedRound?.courseLayoutHoleCount || "EIGHTEEN";
});
